import "../../chunk-7QVYU63E.js";
import { NetworkIdSchema } from "#network/network.js";
import z from "zod";
const JustShippedCardSchema = z.object({
  title: z.string(),
  description: z.string(),
  url: z.string().url(),
  ctaLabel: z.string().optional(),
  networkId: NetworkIdSchema.optional()
});
export {
  JustShippedCardSchema
};
//# sourceMappingURL=justShippedCard.js.map